import React, { useEffect } from 'react';
import { LangService } from './configuration/language';
import { useObserver } from 'mobx-react';
import { SystemConfigStore } from './store';
import { initWuiLoginLanguage } from './languages';
import { RouterProvider } from 'react-router-dom';
import { ConfigProvider, theme as antdTheme } from 'antd';
import viVN from 'antd/locale/vi_VN';
import { RouterLinks } from './routes/router';
import dayjs from 'dayjs';
import { MOMENT_UPDATE_LOCALE_VI } from './constants/configuration.constant';
import updateLocale from 'dayjs/plugin/updateLocale';
import { Toaster } from 'react-hot-toast';
import { useDarkMode } from './hooks';
import { useDispatch } from 'react-redux';
import { AppDispatch, LocalStorageService } from './configuration';
import { fetchProfile } from './redux/features/auth/slice';
import { captureAffRef } from './utils/common/aff-ref';
import UIkit from 'uikit';

initWuiLoginLanguage();

const Root = () => {
  const dispatch = useDispatch<AppDispatch>();

  // Affiliate nội bộ: bắt ?ref= trên mọi trang → lưu để quy công khi mua CAB+/voice/cosmetic.
  useEffect(() => { captureAffRef(); }, []);

  const defaultLanguage = useObserver(() =>
    SystemConfigStore.defaultLanguageSelector()
  );
  const isLogged = LocalStorageService.getItem('accessToken');

  const { isDarkMode } = useDarkMode();

  useEffect(() => {
    if (defaultLanguage && !LangService.instance().hasLocalLanguage()) {
      LangService.instance().changeLanguage(defaultLanguage);
    }
  }, [defaultLanguage]);

  useEffect(() => {
    /**
     * TODO:  When changing languages, remember to updateLocale according to the corresponding language
     */
    dayjs.extend(updateLocale);

    dayjs.updateLocale('en', MOMENT_UPDATE_LOCALE_VI);
  }, []);

  useEffect(() => {
    const { pathname, search } = window.location;
    if (!isLogged) return;
    if (pathname === '/profile') {
      const urlParams = new URLSearchParams(search);

      const openProfile = urlParams.get('open-profile');

      if (!openProfile || openProfile !== 'true') {
        dispatch(fetchProfile());
      }
    } else {
      dispatch(fetchProfile());
    }
  }, []);
  useEffect(() => {
    // Reinitialize UIkit slider
    UIkit.slider('.uk-slider');
    UIkit.drop('.uk-drop');
  }, []);

  return (
    <>
      {/* QA: ConfigProvider gốc cho AntD — dark algorithm theo chế độ + tiếng Việt (bảng "No data" -> "Không có dữ liệu", date picker VN). Modal con kế thừa algorithm này. */}
      <ConfigProvider
        locale={viVN}
        theme={{ algorithm: isDarkMode ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm }}
      >
        <RouterProvider
          router={RouterLinks}
          fallbackElement={<p>Initial·Load...</p>}
        />
      </ConfigProvider>
      <Toaster
        containerStyle={{ top: 72 }}
        toastOptions={{
          // Màu theo class .dark qua CSS var (global.css) -> luôn đọc được ở cả 2 chế độ,
          // không phụ thuộc state isDarkMode (state cục bộ, dễ lệch).
          style: {
            background: 'var(--toast-bg)',
            color: 'var(--toast-fg)',
          },
          className: 'text-sm',
          position: 'top-right',
        }}
      />
    </>
  );
};

export default Root;
